import { DatePicker, Divider, Spin } from "antd";
import ContentLayoutManagement from "../../layouts/ContentLayoutManagement";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import
{
      changeDataBreadcrumb,
      changeLayoutName,
} from "../../store/reducers/layoutSlice";
import { resetAllDrawer } from "../../store/reducers/drawerSlice";
import PieChartComp from "../../components/Dashboard/PieChart";
import VerticalChart from "../../components/Dashboard/VerticalChart";
import { changeValueSearch, getDataDashboardAsync } from "../../store/reducers/dashboardSlice";
import { setLoadingGlobal } from "../../store/reducers/appCommonSlice";
dayjs.locale("vi");

const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";


const DashboardPage = () =>
{
      const { t, i18n } = useTranslation();
      const dispatch = useDispatch();
      const loadingGlobal = useSelector(
            (state: RootState) => state.appCommonSlice.loadingGlobal
      );

      const valueSearch = useSelector((state: RootState) => state.dashboardSlice.valueSearch)

      const [dataTranSac, setDataTranSac] = useState(null)
      const [dataOrderByBranch, setDataOrderByBranch] = useState([])
      const [dataOrderByType, setDataOrderByType] = useState([])

      const renderDivVersion = () =>
      {
            return (
                  <div className="bg-[#1A2032] rounded-lg flex justify-between py-2 px-5 text-white">
                        <p>{t('Utilizing Unit')}: Cục Bản đồ</p>
                        <p>{t('Version')}: 1.0.0</p>
                  </div>
            );
      };

      const renderDivTranSaction = (data?: any) =>
      {
            return (
                  <div className="bg-[#1A2032] rounded-lg p-[20px] relative" style={{ height: data?.data?.length > 4 ? '264px' : '170px' }}>
                        <p className="text-[#86D9FF] mb-[30px]">{t(data?.title)}</p>

                        <div className="grid grid-cols-4 grid-rows-2 gap-x-6 gap-y-12 relative px-2">
                              {
                                    data?.data?.length > 4 && (
                                          <><div className="absolute top-1/2 translate-y-[-50%] left-[8px] w-[calc(25%-60px)] h-[0.5px] bg-[#353B4F]" /><div className="absolute top-1/2 translate-y-[-50%] left-[calc(25%+8px)] w-[calc(25%-60px)] h-[0.5px] bg-[#353B4F]" /><div className="absolute top-1/2 translate-y-[-50%] left-[calc(50%+8px)] w-[calc(25%-60px)] h-[0.5px] bg-[#353B4F]" /><div className="absolute top-1/2 translate-y-[-50%] left-[calc(75%+8px)] w-[calc(25%-60px)] h-[0.5px] bg-[#353B4F]" /></>
                                    )
                              }

                              {data?.data?.map((item: any, ind: number) => (
                                    <div key={ind} className="flex gap-6 px-2">
                                          <img src={item?.icon} />
                                          <div>
                                                <p className="text-des">{t(item?.title)}</p>
                                                <p className="text-white text-[20px] font-semibold">
                                                      {item?.val}
                                                </p>
                                          </div>
                                    </div>
                              ))}
                        </div>
                  </div>
            );
      };

      const getData = async () =>
      {
            dispatch(setLoadingGlobal(true))
            // @ts-ignore
            let res = await dispatch(getDataDashboardAsync({ from: valueSearch?.from?.startOf('day')?.valueOf(), to: valueSearch?.to?.endOf('day')?.valueOf() })).unwrap()
            setDataTranSac(res?.data?.data?.data_tran_sac ?? null)
            setDataOrderByBranch(res?.data?.data?.orders?.by_provider ?? [])
            setDataOrderByType(res?.data?.data?.orders?.by_type ?? [])

            dispatch(setLoadingGlobal(false))

      }

      useEffect(() =>
      {
            dispatch(changeLayoutName("dashboard"));

            return () =>
            {
                  dispatch(changeDataBreadcrumb([]));
                  // @ts-ignore
                  dispatch(changeValueSearch({
                        from: dayjs().subtract(3, "month"),
                        to: dayjs(),
                  }))
                  dispatch(resetAllDrawer());
            };
      }, []);

      useEffect(() =>
      {
            dispatch(changeDataBreadcrumb([{ title: t("Dashboard") }]));
      }, [i18n.language]);

      useEffect(() =>
      {
            getData()
      }, [valueSearch])


      return (
            <ContentLayoutManagement
                  header={
                        <div className="mt-4 flex justify-between text-center items-center pl-6 pr-5 w-full text-white">
                              <p
                                    style={{
                                          fontSize: "20px",
                                          fontWeight: 600,
                                          lineHeight: "26px",
                                    }}
                              >
                                    {t("Dashboard")}
                              </p>
                              <RangePicker
                                    defaultValue={[valueSearch?.from, valueSearch?.to]}
                                    format={dateFormat}
                                    disabledDate={(current) =>
                                          current && current > dayjs().endOf("day")
                                    }

                                    onChange={(val) =>
                                    {// @ts-ignore
                                          dispatch(changeValueSearch({
                                                from: val?.[0],
                                                to: val?.[1]
                                          }))
                                    }}
                                    allowClear={false}
                              />
                        </div>
                  }
            >
                  <Spin spinning={loadingGlobal}>
                        <div className="py-4 px-5">
                              {renderDivVersion()}
                              <div className="mt-4">
                                    {renderDivTranSaction(dataTranSac)}

                              </div>
                              <Divider style={{ background: "#353B4F", margin: "24px 0" }} />

                              <div
                                    className="w-full flex gap-16"
                                    style={{ height: "calc(100vh - 535px)" }}
                              >
                                    <div className="w-1/4 h-full" style={{ borderRight: '1px solid #353B4F' }}>
                                          <p className="text-[#86D9FF]">{t("Product Type Ordered")}</p>

                                          <div className="flex-1 overflow-hidden h-full">
                                                <PieChartComp data={dataOrderByType} t={t} />
                                          </div>
                                    </div>
                                    <div className="w-3/4  h-full">
                                          <p className="text-[#86D9FF]">{t("Orders By Brand")}</p>

                                          <div className="flex-1 overflow-hidden h-full">
                                                <VerticalChart data={dataOrderByBranch} t={t} />
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </Spin>
            </ContentLayoutManagement>
      );
};

export default DashboardPage;
